;var CountriesList_Postnl=["Austria", 
                            "Belgium", 
                            "Czech Republic", 
                            "Denmark", 
                            "France",
                            "Hungary", 
                            "Ireland", 
                            "Italy", 
                            "Luxembourg", 
                            "Netherlands", 
                            "Norway", 
                            "Poland", 
                            "Portugal", 
                            "Slovakia", 
                            "Spain", 
                            "Switzerland"];
var CountriesList_17Track_1=["Bulgaria", 
                               "Croatia", 
                               "Estonia", 
                               "Finland", 
                               "Israel", 
                               "Greece", 
                               "Latvia", 
                               "Lithuania", 
                               "Malta", 
                               "Monaco", 
                               "Romania", 
                               "Slovenia", 
                               "Sweden"];
var CountriesList_17Track_2=["Belarus", 
                               "Ukraine", 
                               "Russian Federation", 
                               "Kazakhstan", 
                               "United Arab Emirates"];
var Countries = {
  "Australia": {
    "Free_Shipping":false,
    "Methods":"AusPost",
    "Price":"1.99",
    "Delivery_days":"2 to 6",
    "Policies":["Free Shipping Over $99"]
  },
  "Canada": {
    "Free_Shipping":false,
    "Methods":"CanadaPost",
    "Price":"5.99",
    "Delivery_days":"4 to 10",
    "Policies":null
  },
  "Germany": {
    "Free_Shipping":false,
    "Methods":"DHL / Asendia UK",
    "Price":"6.99",
    "Delivery_days":"3 to 8",
    "Policies":null
  },
  "Hong Kong": {
    "Free_Shipping":true,
    "Methods":"SF Express",
    "Price":null,
    "Delivery_days":"2 to 3",
    "Policies":null
  },
  "Macao": {
    "Free_Shipping":true,
    "Methods":"SF Express",
    "Price":null,
    "Delivery_days":"2 to 3",
    "Policies":null
  },
  "Japan": {
    "Free_Shipping":false,
    "Methods":"Sagawa Express",
    "Price":"2.99",
    "Delivery_days":"4 to 6",
    "Policies":["Free Shipping Over $99"]
  },
  "Malaysia": {
    "Free_Shipping":true,
    "Methods":"GDExpress",
    "Price":null,
    "Delivery_days":"3 to 5",
    "Policies":null
  },
  "New Zealand": {
    "Free_Shipping":false,
    "Methods":"NZ Post",
    "Price":"5.99",
    "Delivery_days":"6 to 10",
    "Policies":null
  },
  "Singapore": {
    "Free_Shipping":true,
    "Methods":"DragonLink",
    "Price":null,
    "Delivery_days":"3 to 5",
    "Policies":null
  },
  "South Korea": {
    "Free_Shipping":false,
    "Methods":"gzxwl.com",
    "Price":"2.99",
    "Delivery_days":"4 to 6",
    "Policies":["Free Shipping Over $99"]
  },
  "Taiwan": {
    "Free_Shipping":true,
    "Methods":"T-Cat.com.tw / SF Express",
    "Price":null,
    "Delivery_days":"2 to 4",
    "Policies":null
  },
  "United Kingdom": {
    "Free_Shipping":false,
    "Methods":"Yodel.co.uk",
    "Price":"1.99",
    "Delivery_days":"2 to 4",
    "Policies":["Free Shipping Over $99"]
  },
  "United States": {
    "Free_Shipping":false,
    "Methods":"USPS Priority Mail",
    "Price":"1.99",
    "Delivery_days":"2 to 5",
    "Policies":["Free Shipping Over $99"]
  },
  "Postnl": {
    "Free_Shipping":false,
    "Methods":"PostNL / Asendia UK",
    "Price":"9.99",
    "Delivery_days":"5 to 12",
    "Policies":null
  },
  "17Track_1": {
    "Free_Shipping":false,
    "Methods":"17Track.net",
    "Price":"15.99",
    "Delivery_days":"8 to 12",
    "Policies":null
  },
  "17Track_2": {
    "Free_Shipping":false,
    "Methods":"17Track.net",
    "Price":"11.99",
    "Delivery_days":"10 to 15",
    "Policies":null
  }
};

if (typeof Shopify.Cart === "undefined") {
    Shopify.Cart = {}
}
Shopify.Cart.ShippingCalculator = function () {
    var _config = {
        submitButton: "Calculate shipping",
        submitButtonDisabled: "Calculating...",
        templateId: "shipping-calculator-response-template",
        wrapperId: "wrapper-response",
        customerIsLoggedIn: false,
        moneyFormat: "$ "
    };  
    var $wrapperResponse=jQuery("#" + _config.wrapperId);  
    var _render = function (e) {
        var $template = jQuery("#" + _config.templateId);
        if ($template.length && $wrapperResponse.length) {
            $template.tmpl(e).appendTo($wrapperResponse);
            if (typeof Currency !== "undefined" && typeof Currency.convertAll === "function") {
                var r = "";
                if (jQuery("[name=currencies]").size()) {
                    r = jQuery("[name=currencies]").val()
                } else {
                    if (jQuery("#currencies span.selected").size()) {
                        r = jQuery("#currencies span.selected").attr("data-currency")
                    }
                }
                if (r !== "") {
                    Currency.convertAll(shopCurrency, r, "#wrapper-response span.money")
                }
            }
        }
    };  
    var _enableButtons = function () {
        jQuery("#get-rates-submit").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)
    };  
    var _disableButtons = function () {
        jQuery("#get-rates-submit").val(_config.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled")
    };  
    var _getShippingRates = function (country) {
        _enableButtons();
        var initial_country=country;
        if (jQuery.inArray(country,CountriesList_17Track_2)>-1){
          country="17Track_2";
        };
        if (jQuery.inArray(country,CountriesList_17Track_1)>-1){
          country="17Track_1";
        };
        if (jQuery.inArray(country,CountriesList_Postnl)>-1){
          country="Postnl";
        };
        if (typeof country === "string" && Countries[country]){
          _render({
              rates: Countries[country],
              address: initial_country,
              success: true
          });
          $wrapperResponse.fadeIn();
        }
        else{
          var feedback = "We do not ship to this destination.";
          _render({
              rates: [],
              errorFeedback: feedback,
              success: false
          });
          $wrapperResponse.show();
        }
    };
    var _formatRate = function (e) {
        function i(e) {
            return e.replace(/(\d+)(\d{3}[\.,]?)/, "$1,$2")
        }
        function s(e, t) {
            var n = e.toFixed(t).toString();
            if (n.match(/^\.\d+/)) {
                return "0" + n
            } else {
                return n
            }
        }
        if (typeof e == "string") {
            e = e.replace(".", "")
        }
        var t = "";
        var n = /\{\{\s*(\w+)\s*\}\}/;
        var r = _config.moneyFormat;
        switch (r.match(n)[1]) {
            case "amount":
                t = i(s(e / 100, 2));
                break;
            case "amount_no_decimals":
                t = i(s(e / 100, 0));
                break;
            case "amount_with_comma_separator":
                t = s(e / 100, 2).replace(/\./, ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                t = i(s(e / 100, 0)).replace(/\./, ",");
                break
        }
        return r.replace(n, t)
    };
    var _initCountry= function() {
		var default_country = jQuery("#address_country").attr("data-default");
        var countrylist=jQuery("#address_country").get(0);
        countrylist.selectedIndex = 0;
        if(default_country){
          for (var n = 0,country_len = countrylist.options.length; n < country_len; n++) {
              var country = countrylist.options[n];
              if (default_country == country.value || default_country == country.innerHTML){
                countrylist.selectedIndex = n;
              }
          }
        }
	};
    _init = function () {
        //Automatic country selection
        _initCountry();
        jQuery("#get-rates-submit").click(function (e) {
            e.preventDefault();
            _disableButtons();
            $wrapperResponse.empty().hide();
            var country = jQuery("#address_country").val() || "";
            _getShippingRates(country);
        });
        if (_config.customerIsLoggedIn) {
            jQuery("#get-rates-submit").trigger("click")
        }
    };
    return {
        show: function (e) {
            e = e || {};
            jQuery.extend(_config, e);
            jQuery(function () {
                _init()
            })
        },
        getConfig: function () {
            return _config
        },
        formatRate: function (price) {
            return _formatRate(price)
        }
    }
}();


